import { useState } from 'react'

/**
 * `Page` (`api/dist/openapi.bundled.yaml`): "an opaque continuation, and nothing else — no total,
 * no offset, no page number" (§24.2 rule 25, §32.8). There is no `prev_cursor` anywhere in the
 * contract, so "back" is a client-side stack of the cursors already visited, not a second server
 * value — the server only ever hands forward.
 */
export function useCursorPager() {
  const [stack, setStack] = useState<readonly (string | undefined)[]>([undefined])
  const cursor = stack[stack.length - 1]

  return {
    cursor,
    hasPrev: stack.length > 1,
    goNext(nextCursor: string): void {
      setStack((s) => [...s, nextCursor])
    },
    goPrev(): void {
      setStack((s) => (s.length > 1 ? s.slice(0, -1) : s))
    },
    reset(): void {
      setStack([undefined])
    },
  }
}
